module.exports = __webpack_public_path__ + "img/top1.32f1bcc0.png";